import React from 'react'
import UserTable from './UserTable';
const Users = () => {
  return (
    <div>
    <h1 className="text-left text-white text-3xl font-bold mb-4">
      Dispatch Users
    </h1>
        <UserTable/>
    </div>
  )
}

export default Users;